import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import useAuth from '~/hooks/useAuth';

/**
 * Identifies users and tracks route changes in Heap.io analytics (only in production).
 *
 * TRMA-708: Enhanced user identification that tracks users across TRM, TopstepX, and WordPress domains.
 * - Identifies users by screenName (consistent identifier across all domains)
 * - Tracks user properties: email, userid
 * - Adds event properties: screen_resolution, viewport_resolution, device_pixel_ratio
 */
const HeapRouteTracker = () => {
  const location = useLocation();
  const auth = useAuth();

  useEffect(() => {
    if (
      (process.env.ENVIRO === 'production' || process.env.ENVIRO === 'prod') &&
      auth?.isLoggedIn &&
      auth?.user?.screenName &&
      auth?.user?.userId &&
      auth?.user?.email
    ) {
      // @ts-ignore - heap is loaded via script tag
      if (typeof window !== 'undefined' && window.heap) {
        // @ts-ignore
        window.heap.identify(auth.user.email);

        // @ts-ignore
        window.heap.addUserProperties({
          email: auth.user.email,
          userid: auth.user.userId,
        });

        // @ts-ignore
        window.heap.clearEventProperties();

        // @ts-ignore
        window.heap.addEventProperties({
          screen_resolution: `${window.screen.width}x${window.screen.height}`,
          viewport_resolution: `${window.innerWidth}x${window.innerHeight}`,
          device_pixel_ratio: window.devicePixelRatio || 1,
        });
      }
    }
  }, [location, auth?.isLoggedIn, auth?.user?.screenName, auth?.user?.userId, auth?.user?.email]);

  return null;
};

export default HeapRouteTracker;
